export const range = (start, end) => {
  return [...Array(Math.abs(end + 1 - start)).keys()].map((x) => x + start);
};
